/**
 * Gravity Backdrops — Shopify Cart API + cart drawer + cart page
 */
(function () {
  const root = document.documentElement;
  const orderBumpVariantId = root.dataset.orderBumpVariant || '';

  const drawer = () => document.getElementById('cart-drawer');
  const overlay = () => document.getElementById('cart-overlay');

  function cartListEls() {
    return [
      document.getElementById('cart-items-list'),
      document.getElementById('cart-page-items'),
    ].filter(Boolean);
  }

  function cartFeesWrapEls() {
    return [
      document.getElementById('cart-fees'),
      document.getElementById('cart-page-fees'),
    ].filter(Boolean);
  }

  function cartFeesListEls() {
    return [
      document.getElementById('cart-fees-list'),
      document.getElementById('cart-page-fees-list'),
    ].filter(Boolean);
  }

  function subtotalEls() {
    return [
      document.getElementById('cart-subtotal'),
      document.getElementById('cart-page-subtotal'),
    ].filter(Boolean);
  }

  function estimatedShippingRowEls() {
    return [document.getElementById('cart-estimated-shipping-row')].filter(Boolean);
  }

  function meterFillEls() {
    return [
      document.getElementById('meter-fill'),
      document.getElementById('meter-fill-page'),
    ].filter(Boolean);
  }

  function meterBannerEls() {
    return [
      document.getElementById('meter-banner'),
      document.getElementById('meter-banner-page'),
    ].filter(Boolean);
  }

  function meterSectionEls() {
    return Array.from(document.querySelectorAll('.cart-shipping-meter'));
  }

  function checkoutBtns() {
    return [
      document.getElementById('cart-checkout-btn'),
      document.getElementById('cart-page-checkout-btn'),
    ].filter(Boolean);
  }

  function isCartPage() {
    return !!document.getElementById('cart-page-items');
  }

  function setAllInnerHtml(els, html) {
    els.forEach(function (el) {
      el.innerHTML = html;
    });
  }

  function setAllText(els, text) {
    els.forEach(function (el) {
      el.textContent = text;
    });
  }

  function setAllDisabled(els, disabled) {
    els.forEach(function (el) {
      el.disabled = disabled;
    });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-EU', {
      style: 'currency',
      currency: 'EUR',
    }).format(cents / 100);
  }

  function escAttr(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function lineProperties(item) {
    const raw = item && item.properties;
    if (!raw) return {};
    if (Array.isArray(raw)) {
      const out = {};
      raw.forEach(function (pair) {
        if (pair && pair.name != null) out[String(pair.name)] = pair.value;
      });
      return out;
    }
    return raw;
  }

  function isSurchargeItem(item) {
    const guard = window.GravityPackageDiscount;
    if (guard && typeof guard.isSurchargeCartItem === 'function') {
      return guard.isSurchargeCartItem(item);
    }
    const productType = String((item && item.product_type) || '')
      .trim()
      .toLowerCase();
    return productType === 'mws_fee_generated';
  }

  function isSurchargeWrapperItem(item) {
    const url = String((item && item.url) || '').toLowerCase();
    return url.indexOf('/products/additional-fees') !== -1;
  }

  function shouldShowSurchargeInFooter(item) {
    if (!isSurchargeItem(item)) return false;
    if (isSurchargeWrapperItem(item) && (item.final_line_price || 0) <= 0) {
      return false;
    }
    return true;
  }

  function surchargeDisplayLabel(item) {
    const title = String(item.product_title || '').trim();
    if (title.toLowerCase() === 'additional fees') return 'Handling fee';
    return title || 'Fee';
  }

  function partitionCartEntries(entries) {
    const main = [];
    const fees = [];
    entries.forEach(function (entry) {
      if (
        entry.kind === 'line' &&
        entry.item &&
        shouldShowSurchargeInFooter(entry.item)
      ) {
        fees.push(entry);
        return;
      }
      main.push(entry);
    });
    return { main: main, fees: fees };
  }

  function lineItemMeta(item) {
    const p = lineProperties(item);
    const parts = [];
    if (p._package) parts.push(p._package);
    if (p._slot_label) parts.push(p._slot_label);
    else if (p._slot) parts.push('Slot ' + p._slot);
    if (item.variant_title && item.variant_title !== 'Default Title') {
      parts.push(item.variant_title);
    }
    return parts.join(' · ');
  }

  function packageHandleFromItem(item, cart) {
    if (isSurchargeItem(item)) return '';
    const handle = String(lineProperties(item)._package_handle || '').trim();
    if (handle) return handle;
    if (
      cart &&
      cart.attributes &&
      cart.attributes['Package handle'] &&
      (item.has_components ||
        lineProperties(item)._package ||
        (window.GravityPackageDiscount &&
          window.GravityPackageDiscount.isPackageCartItem &&
          window.GravityPackageDiscount.isPackageCartItem(item)))
    ) {
      return String(cart.attributes['Package handle']).trim();
    }
    return '';
  }

  function cartDisplayTotalCents(cart) {
    const guard = window.GravityPackageDiscount;
    if (guard && guard.packageDisplayTotalCents && guard.promotionsExcludeBogo(cart)) {
      return guard.packageDisplayTotalCents(cart);
    }
    return cart.total_price || 0;
  }

  const CANVAS_PRODUCT_TYPES = new Set([
    'XS',
    'Standard',
    'Mid',
    'Large',
    'Large+',
    'XL',
    'XXL',
    'XXXL',
    'Large Double sided',
    'Standard Double sided',
  ]);

  function isCanvasCartItem(item) {
    const p = lineProperties(item);
    if (p._canvas_size || p._package_handle || p._package) return true;
    const type = String(item.product_type || '').trim();
    return CANVAS_PRODUCT_TYPES.has(type);
  }

  function addBundleEntryVariantIds(ids, entry) {
    if (!entry) return;
    if (entry.variant_id) ids.add(String(entry.variant_id));
    (entry.components || []).forEach(function (comp) {
      if (comp.variant_id) ids.add(String(comp.variant_id));
    });
  }

  function collectCartVariantIds(cart) {
    const ids = new Set();
    if (!cart || !cart.items) return ids;

    cart.items.forEach(function (item) {
      if (!isCanvasCartItem(item)) return;
      if (item.variant_id) ids.add(String(item.variant_id));
      itemComponentsList(item).forEach(function (comp) {
        if (comp.variant_id) ids.add(String(comp.variant_id));
      });
    });

    const bundleByKey = cart._bundleByKey || {};
    Object.keys(bundleByKey).forEach(function (key) {
      addBundleEntryVariantIds(ids, bundleByKey[key]);
    });

    return ids;
  }

  async function isVariantInCart(variantId, cart) {
    if (!variantId) return false;
    const source = cart || (await fetchCartWithBundles());
    return collectCartVariantIds(source).has(String(variantId));
  }

  function itemComponentsList(item) {
    const raw = item && item.item_components;
    return Array.isArray(raw) ? raw : [];
  }

  function componentImageSrc(comp) {
    return (
      comp.image ||
      comp.featured_image?.url ||
      'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
    );
  }

  function normalizeComponent(comp) {
    const qty = comp.quantity || 1;
    const title =
      comp.title || comp.product_title || comp.line_title || 'Canvas';
    return {
      key: comp.key || '',
      quantity: qty,
      title: title,
      image: componentImageSrc(comp),
      label: comp.label || comp.variant_title || '',
    };
  }

  async function fetchBundleComponentsMap() {
    try {
      const res = await fetch(cartApiUrl('/') + '?sections=cart-bundle-data', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!res.ok) return {};
      const sections = await res.json();
      const html = sections['cart-bundle-data'];
      if (!html) return {};
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const node = doc.getElementById('cart-bundle-data-json');
      if (!node || !node.textContent) return {};
      const data = JSON.parse(node.textContent);
      return data.items || {};
    } catch (err) {
      console.warn('[GravityCart] bundle section data unavailable', err);
      return {};
    }
  }

  async function fetchCartWithBundles() {
    const cart = await fetchCart();
    cart._bundleByKey = await fetchBundleComponentsMap();
    return cart;
  }

  async function reconcilePackageDiscount(cart) {
    if (!window.GravityPackageDiscount || !cart) return cart;
    try {
      return await window.GravityPackageDiscount.reconcile(cart);
    } catch (err) {
      console.warn('[GravityCart] package discount reconcile failed', err);
      return cart;
    }
  }

  function buildCartDisplayEntries(cart) {
    const items = cart.items;
    const bundleByKey = cart._bundleByKey || {};
    const byHandle = {};
    const entries = [];
    const consumed = new Set();

    items.forEach(function (item, index) {
      const handle = packageHandleFromItem(item, cart);
      if (handle) {
        if (!byHandle[handle]) byHandle[handle] = [];
        byHandle[handle].push({ item: item, index: index });
      }
    });

    function packageLineCount(items) {
      return items.filter(function (item) {
        return !!packageHandleFromItem(item, cart);
      }).length;
    }

    function bundleDisplayPriceCents(group, cart) {
      const handle = group[0] && packageHandleFromItem(group[0].item, cart);
      const guard = window.GravityPackageDiscount;
      if (
        handle &&
        guard &&
        guard.packageTargetCentsForCart &&
        guard.promotionsExcludeBogo(cart)
      ) {
        const target = guard.packageTargetCentsForCart(cart);
        if (target > 0) return target;
      }

      const lineSum = group.reduce(function (sum, row) {
        return sum + (row.item.final_line_price || 0);
      }, 0);
      const pkgLines = packageLineCount(cart.items);
      if (pkgLines > 0 && pkgLines === cart.items.length && cart.total_price > 0) {
        return cartDisplayTotalCents(cart);
      }
      if (lineSum > 0 && cart.total_price > 0 && cart.total_price < lineSum) {
        return cartDisplayTotalCents(cart);
      }
      return lineSum;
    }

    function bundleFromGroup(handle, group) {
      const first = group[0].item;
      const firstProps = lineProperties(first);
      const title =
        firstProps._package ||
        (cart.attributes && cart.attributes['Studio package']) ||
        handle;
      const components = group.map(function (row) {
        const props = lineProperties(row.item);
        return normalizeComponent({
          key: row.item.key,
          quantity: row.item.quantity,
          title: row.item.product_title,
          image: row.item.image,
          label: props._slot_label || '',
          variant_title: row.item.variant_title,
        });
      });
      return {
        kind: 'bundle',
        handle: handle,
        title: title,
        quantity: 1,
        priceCents: bundleDisplayPriceCents(group, cart),
        parentKey: first.key,
        removeKeys: group.map(function (row) {
          return row.item.key;
        }),
        components: components,
        merged: false,
      };
    }

    function bundleFromParent(item, components) {
      const title =
        item.product_title ||
        item.title ||
        (cart.attributes && cart.attributes['Studio package']) ||
        'Studio package';
      const guard = window.GravityPackageDiscount;
      const priceCents =
        guard &&
        guard.packageDisplayTotalCents &&
        guard.promotionsExcludeBogo(cart)
          ? guard.packageDisplayTotalCents(cart)
          : item.final_line_price || 0;
      return {
        kind: 'bundle',
        handle: (cart.attributes && cart.attributes['Package handle']) || '',
        title: title,
        quantity: item.quantity || 1,
        priceCents: priceCents,
        parentKey: item.key,
        removeKeys: [item.key],
        components: components.map(normalizeComponent),
        merged: true,
      };
    }

    Object.keys(byHandle).forEach(function (handle) {
      const group = byHandle[handle];
      if (group.length < 2) return;
      group.forEach(function (row) {
        consumed.add(row.index);
      });
      entries.push(bundleFromGroup(handle, group));
    });

    items.forEach(function (item, index) {
      if (consumed.has(index)) return;

      const liquidBundle = bundleByKey[item.key];
      const liquidComponents =
        liquidBundle && liquidBundle.components ? liquidBundle.components : [];
      const ajaxComponents = itemComponentsList(item);

      if (
        !isSurchargeItem(item) &&
        (item.has_components ||
        ajaxComponents.length > 0 ||
        liquidComponents.length > 0)
      ) {
        consumed.add(index);
        const components =
          ajaxComponents.length > 0
            ? ajaxComponents
            : liquidComponents.map(function (comp) {
                return {
                  quantity: comp.quantity,
                  title: comp.title,
                  image: comp.image,
                  variant_title: comp.variant_title,
                };
              });
        entries.push(bundleFromParent(item, components));
        return;
      }

      const handle = packageHandleFromItem(item, cart);
      if (handle) {
        consumed.add(index);
        entries.push(
          bundleFromGroup(handle, [{ item: item, index: index }])
        );
        return;
      }

      entries.push({ kind: 'line', item: item, index: index });
    });

    return entries;
  }

  function buildCartDisplayEntriesSafe(cart) {
    try {
      return buildCartDisplayEntries(cart);
    } catch (err) {
      console.warn('[GravityCart] bundle layout failed, showing flat list', err);
      return cart.items.map(function (item, index) {
        return { kind: 'line', item: item, index: index };
      });
    }
  }

  async function parseCartError(res) {
    try {
      const data = await res.json();
      return (
        data.description ||
        data.message ||
        (data.errors && String(data.errors)) ||
        'Could not update your bag (' + res.status + ')'
      );
    } catch (e) {
      return 'Could not update your bag (' + res.status + ')';
    }
  }

  function shopifyRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function cartApiUrl(path) {
    const root = shopifyRoot();
    const base = root.endsWith('/') ? root.slice(0, -1) : root;
    return base + path;
  }

  function cartJsonUrl() {
    return cartApiUrl('/cart.js');
  }

  let renderSeq = 0;
  let shopSyncSeq = 0;
  let lastShopCartVariantIds = null;

  function applyShopCardStates(cards, ids) {
    if (!cards || !cards.length || !ids) return;
    cards.forEach(function (card) {
      const variantId = card.getAttribute('data-variant-id');
      const inCart = variantId && ids.has(String(variantId));
      card.classList.toggle('is-in-cart', !!inCart);
      const quickLabel = card.querySelector('.gravity-shop__card-quick-label');
      if (quickLabel) {
        quickLabel.textContent = inCart ? 'Already in your bag' : 'Quick view';
      }
      const title = card.getAttribute('data-title') || 'Backdrop';
      if (inCart) {
        card.setAttribute('aria-label', title + ' — already in your bag');
      } else {
        card.removeAttribute('aria-label');
      }
    });
  }

  function syncShopCardsFromCache() {
    if (!lastShopCartVariantIds) return;
    const cards = document.querySelectorAll(
      '[data-product-card][data-variant-id]'
    );
    if (!cards.length) return;
    applyShopCardStates(cards, lastShopCartVariantIds);
  }

  async function syncShopCards() {
    const seq = ++shopSyncSeq;
    let ids;
    try {
      const cart = await fetchCartWithBundles();
      ids = collectCartVariantIds(cart);
    } catch (err) {
      console.warn('[GravityCart] shop in-cart sync failed', err);
      return;
    }
    if (seq !== shopSyncSeq) return;

    lastShopCartVariantIds = ids;
    const cards = document.querySelectorAll(
      '[data-product-card][data-variant-id]'
    );
    if (!cards.length) return;
    applyShopCardStates(cards, ids);
  }

  async function fetchCart(attempt) {
    const tries = attempt || 2;
    let lastErr;
    for (let i = 0; i < tries; i++) {
      try {
        const res = await fetch(cartJsonUrl(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        });
        if (!res.ok) throw new Error('Failed to load cart (' + res.status + ')');
        const cart = await res.json();
        if (!cart || !Array.isArray(cart.items)) {
          throw new Error('Invalid cart response');
        }
        return cart;
      } catch (err) {
        lastErr = err;
        if (i < tries - 1) {
          await new Promise(function (r) {
            setTimeout(r, 250);
          });
        }
      }
    }
    throw lastErr;
  }

  function lineKeyFromEl(el) {
    if (!el) return '';
    return (
      el.getAttribute('data-key') ||
      el.closest('[data-line-key]')?.getAttribute('data-line-key') ||
      ''
    );
  }

  async function postCartChange(body) {
    const res = await fetch(cartApiUrl('/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(await parseCartError(res));
    return res.json();
  }

  async function postCartUpdate(body) {
    const res = await fetch(cartApiUrl('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(await parseCartError(res));
    return res.json();
  }

  function resolveCartLine(cart, key, lineHint) {
    let lineIndex = -1;
    const lineKey = key ? String(key) : '';

    if (lineKey) {
      lineIndex = cart.items.findIndex(function (item) {
        return item.key === lineKey;
      });
    }

    if (lineIndex < 0) {
      const hint = Number(lineHint);
      if (hint > 0 && hint <= cart.items.length) {
        lineIndex = hint - 1;
      }
    }

    const item = lineIndex >= 0 ? cart.items[lineIndex] : null;
    return {
      lineKey: item ? item.key : lineKey,
      lineIndex: lineIndex,
      item: item,
    };
  }

  async function setCartLineQuantity({ key, line, quantity, trigger }) {
    const row = trigger?.closest('.cart-item');
    if (row) row.classList.add('is-updating');
    if (trigger) trigger.disabled = true;

    try {
      const cart = await fetchCart();
      const resolved = resolveCartLine(cart, key, line);
      const qty = Math.max(0, Number(quantity) || 0);

      if (!resolved.item || !resolved.lineKey) {
        if (qty === 0) {
          await renderCart();
          return;
        }
        throw new Error('This item is no longer in your bag.');
      }

      try {
        await postCartUpdate({ updates: { [resolved.lineKey]: qty } });
      } catch (updateErr) {
        await postCartChange({ line: resolved.lineIndex + 1, quantity: qty });
      }

      await renderCart();
    } catch (err) {
      console.error(err);
      alert(err.message || 'Could not update your bag. Try again.');
    } finally {
      if (row) row.classList.remove('is-updating');
      if (trigger) trigger.disabled = false;
    }
  }

  function updateCartLine(opts) {
    return setCartLineQuantity(opts);
  }

  async function removeBundleLines(keys, trigger) {
    if (trigger) trigger.disabled = true;
    const row = trigger?.closest('.cart-bundle');
    if (row) row.classList.add('is-updating');
    try {
      const updates = {};
      keys.forEach(function (key) {
        updates[key] = 0;
      });
      await postCartUpdate({ updates: updates });
      await renderCart();
    } catch (err) {
      console.error(err);
      alert(err.message || 'Could not remove this package. Try again.');
    } finally {
      if (row) row.classList.remove('is-updating');
      if (trigger) trigger.disabled = false;
    }
  }

  function handleCartListClick(e) {
    const toggleBtn = e.target.closest('[data-bundle-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      const bundle = toggleBtn.closest('.cart-bundle');
      const panel = bundle?.querySelector('[data-bundle-panel]');
      const label = toggleBtn.querySelector('.cart-bundle__toggle-label');
      const expanded = toggleBtn.getAttribute('aria-expanded') !== 'false';
      const nextExpanded = !expanded;
      toggleBtn.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      if (panel) panel.hidden = !nextExpanded;
      if (label && bundle) {
        const count = bundle.querySelectorAll('.cart-bundle__component').length;
        label.textContent = nextExpanded
          ? 'Hide ' + count + (count === 1 ? ' item' : ' items')
          : 'Show ' + count + (count === 1 ? ' item' : ' items');
      }
      return;
    }

    const removeBundleBtn = e.target.closest('[data-cart-remove-bundle]');
    if (removeBundleBtn) {
      e.preventDefault();
      e.stopPropagation();
      const keys = (removeBundleBtn.getAttribute('data-bundle-keys') || '')
        .split(',')
        .map(function (k) {
          return k.trim();
        })
        .filter(Boolean);
      if (keys.length) removeBundleLines(keys, removeBundleBtn);
      return;
    }

    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const row = removeBtn.closest('.cart-item');
      setCartLineQuantity({
        key: lineKeyFromEl(removeBtn),
        line: parseInt(
          removeBtn.getAttribute('data-line') ||
            row?.getAttribute('data-line-index') ||
            '0',
          10
        ),
        quantity: 0,
        trigger: removeBtn,
      });
      return;
    }
  }

  function bindCartListActions() {
    ['cart-items-list', 'cart-page-items'].forEach(function (id) {
      const el = document.getElementById(id);
      if (!el || el.dataset.cartActionsBound === 'true') return;
      el.dataset.cartActionsBound = 'true';
      el.addEventListener('click', handleCartListClick);
    });
  }

  async function addVariant(variantId, quantity = 1, opts = {}) {
    if (opts.isCanvas && !opts.skipDuplicateGuard) {
      const cart = await fetchCartWithBundles();
      if (await isVariantInCart(variantId, cart)) {
        if (!opts.skipDrawer) openCartDrawer();
        document.dispatchEvent(
          new CustomEvent('gravity:cart-duplicate', {
            detail: { variantId: String(variantId) },
          })
        );
        return { duplicate: true };
      }
    }

    const body = { id: variantId, quantity: quantity };
    if (opts.properties) body.properties = opts.properties;

    const res = await fetch(cartApiUrl('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(await parseCartError(res));

    if (window.GravityBogoFunnel && window.GravityBogoFunnel.clearCheckoutSkip) {
      window.GravityBogoFunnel.clearCheckoutSkip();
    }

    await renderCart();

    if (opts.skipBogoPrompt) {
      if (!opts.skipDrawer) openCartDrawer();
      return { duplicate: false };
    }

    if (window.GravityBogoFunnel && window.GravityBogoFunnel.maybePrompt) {
      const cart = await fetchCartWithBundles();
      const prompted = await window.GravityBogoFunnel.maybePrompt(cart, {
        reason: 'add',
      });
      if (prompted) return { duplicate: false };
    }

    if (!opts.skipDrawer) openCartDrawer();
    return { duplicate: false };
  }

  function updateCartBadge(count) {
    document.querySelectorAll('.cart-count').forEach((badge) => {
      badge.textContent = count;
      badge.dataset.visible = count > 0 ? 'true' : 'false';
    });
  }

  function updateShippingMeter(cart) {
    const isEmpty = !cart || !cart.item_count;
    estimatedShippingRowEls().forEach(function (row) {
      row.hidden = isEmpty;
    });

    meterSectionEls().forEach(function (section) {
      section.hidden = true;
    });
    meterFillEls().forEach(function (fill) {
      fill.style.width = '0%';
      fill.classList.remove('is-unlocked');
    });
    meterBannerEls().forEach(function (banner) {
      banner.innerHTML = '';
    });

    if (isEmpty) return;
  }

  function renderBundleHtml(bundle, bundleIndex) {
    const count = bundle.components.length;
    const toggleLabel = 'Hide ' + count + (count === 1 ? ' item' : ' items');
    const imageSrc =
      (bundle.components[0] && bundle.components[0].image) ||
      'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    const componentsHtml = bundle.components
      .map(function (comp) {
        return `
        <li class="cart-bundle__component">
          <img class="cart-bundle__component-img" src="${escAttr(comp.image)}" alt="" width="40" height="40" loading="lazy">
          <span class="cart-bundle__component-label">${escAttr(comp.quantity)} × ${escAttr(comp.title)}</span>
        </li>`;
      })
      .join('');

    const removeKeys = (bundle.removeKeys || [bundle.parentKey]).join(',');

    return `
      <article class="cart-bundle" data-bundle-id="${bundleIndex}" data-line-key="${escAttr(bundle.parentKey)}" data-bundle-keys="${escAttr(removeKeys)}">
        <div class="cart-bundle__header">
          <div class="cart-bundle__media">
            <img src="${escAttr(imageSrc)}" alt="${escAttr(bundle.title)}" width="72" height="72" loading="lazy">
            <span class="cart-bundle__qty-badge" aria-hidden="true">${bundle.quantity}</span>
          </div>
          <div class="cart-bundle__summary">
            <h4 class="cart-bundle__title">${escAttr(bundle.title)}</h4>
            <button type="button" class="cart-bundle__toggle" data-bundle-toggle aria-expanded="true">
              <span class="cart-bundle__toggle-label">${escAttr(toggleLabel)}</span>
              <span class="cart-bundle__chevron" aria-hidden="true"></span>
            </button>
          </div>
          <p class="cart-bundle__price">${formatMoney(bundle.priceCents)}</p>
        </div>
        <ul class="cart-bundle__components" data-bundle-panel>${componentsHtml}</ul>
        <button type="button" class="cart-item-remove cart-bundle__remove" data-cart-remove-bundle data-key="${escAttr(bundle.parentKey)}" data-bundle-keys="${escAttr(removeKeys)}">
          Remove package
        </button>
      </article>`;
  }

  function updateBogoStrip(cart) {
    if (!window.GravityBogoFunnel || !window.GravityBogoFunnel.renderStrip) return;
    ['cart-bogo-strip', 'cart-page-bogo-strip'].forEach(function (id) {
      const strip = document.getElementById(id);
      if (strip) window.GravityBogoFunnel.renderStrip(cart, strip);
    });
  }

  function updateBogoSavingsRow(cart) {
    const rows = [
      document.getElementById('cart-bogo-savings-row'),
      document.getElementById('cart-page-bogo-savings-row'),
    ].filter(Boolean);

    if (!rows.length || !window.GravityBogoFunnel) {
      return;
    }

    if (
      window.GravityBogoFunnel.bogoPromotionsBlocked &&
      window.GravityBogoFunnel.bogoPromotionsBlocked(cart)
    ) {
      rows.forEach(function (row) {
        row.hidden = true;
        row.innerHTML = '';
      });
      return;
    }

    const savings = window.GravityBogoFunnel.bogoSavingsCents
      ? window.GravityBogoFunnel.bogoSavingsCents(cart)
      : 0;
    const freeCount = window.GravityBogoFunnel.bogoDiscountedCount
      ? window.GravityBogoFunnel.bogoDiscountedCount(cart)
      : 0;

    if (savings <= 0 || freeCount < 1) {
      rows.forEach(function (row) {
        row.hidden = true;
        row.innerHTML = '';
      });
      return;
    }

    const label =
      freeCount > 1
        ? 'Buy one, get one (' + freeCount + ' free)'
        : 'Buy one, get one';

    const html =
      '<span class="cart-bogo-savings__label">' +
      escAttr(label) +
      '</span>' +
      '<span class="cart-bogo-savings__value">−' +
      formatMoney(savings) +
      '</span>';

    rows.forEach(function (row) {
      row.hidden = false;
      row.innerHTML = html;
    });
  }

  function renderSurchargeFeeHtml(item) {
    return (
      '<div class="cart-fees__row">' +
      '<span class="cart-fees__label">' +
      escAttr(surchargeDisplayLabel(item)) +
      '</span>' +
      '<span class="cart-fees__amount">' +
      formatMoney(item.final_line_price || 0) +
      '</span>' +
      '</div>'
    );
  }

  function updateCartFeesSection(feeEntries) {
    const wraps = cartFeesWrapEls();
    const lists = cartFeesListEls();
    const html = feeEntries
      .map(function (entry) {
        return renderSurchargeFeeHtml(entry.item);
      })
      .join('');

    lists.forEach(function (list) {
      list.innerHTML = html;
    });
    wraps.forEach(function (wrap) {
      wrap.hidden = feeEntries.length === 0;
    });
  }

  function renderCartItemHtml(item, index, cart) {
    const meta = lineItemMeta(item);
    const metaHtml = meta
      ? `<p class="cart-item-options">${escAttr(meta)}</p>`
      : '';

    const imageSrc =
      item.image ||
      item.featured_image?.url ||
      'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    return `
      <div class="cart-item" data-line-key="${escAttr(item.key)}" data-line-index="${index + 1}">
        <div class="cart-item-img">
          <img src="${escAttr(imageSrc)}" alt="${escAttr(item.product_title)}" width="72" height="72" loading="lazy">
        </div>
        <div class="cart-item-details">
          <h4 class="cart-item-title">${escAttr(item.product_title)}</h4>
          ${metaHtml}
          <div class="cart-item-row">
            <span class="cart-item-price">${formatMoney(item.final_line_price)}</span>
          </div>
          <button type="button" class="cart-item-remove" data-cart-remove data-key="${escAttr(item.key)}" data-line="${index + 1}">
            Remove
          </button>
        </div>
      </div>`;
  }

  function renderCartErrorHtml() {
    return `
      <div class="cart-empty-state">
        <p>Unable to load cart.</p>
        <button type="button" class="btn btn-secondary" data-cart-retry>Try again</button>
      </div>`;
  }

  function packageTargetCentsFromCart(cart) {
    const handle =
      (cart.attributes && cart.attributes['Package handle']) || '';
    if (!handle || !window.GRAVITY_PACKAGES) return 0;
    const pkg = window.GRAVITY_PACKAGES[handle];
    return pkg && pkg.packagePriceCents ? pkg.packagePriceCents : 0;
  }

  function updatePackageDiscountRow(cart) {
    const row = document.getElementById('cart-package-discount-row');
    if (!row) return;

    const targetCents = packageTargetCentsFromCart(cart);
    const discountCents = cart.total_discount || 0;
    const pkgOnly =
      cart.items &&
      cart.items.length > 0 &&
      cart.items.every(function (item) {
        return !!packageHandleFromItem(item, cart);
      });

    const guard = window.GravityPackageDiscount;
    const qualifies =
      guard &&
      guard.findQualifyingHandle &&
      guard.findQualifyingHandle(cart);
    const pricingApplied =
      guard &&
      guard.packagePricingApplied &&
      qualifies &&
      guard.packagePricingApplied(cart, qualifies);
    const stalePkgDiscount =
      discountCents > 0 && !qualifies && guard && guard.getAppliedPkgCodes;

    if (pricingApplied && discountCents > 0) {
      row.hidden = false;
      row.innerHTML =
        '<span>Package discount</span><span>−' +
        formatMoney(discountCents) +
        '</span>';
      return;
    }

    if (pricingApplied && targetCents > 0) {
      row.hidden = false;
      row.innerHTML =
        '<span>Package price</span><span>' +
        formatMoney(targetCents) +
        '</span>';
      return;
    }

    if (stalePkgDiscount && guard.getAppliedPkgCodes(cart).length) {
      row.hidden = false;
      row.innerHTML =
        '<span class="cart-package-discount-stale">Removing invalid package discount…</span>';
      return;
    }

    if (discountCents > 0 && qualifies) {
      row.hidden = false;
      row.innerHTML =
        '<span>Package discount</span><span>−' +
        formatMoney(discountCents) +
        '</span>';
      return;
    }

    if (
      pkgOnly &&
      targetCents > 0 &&
      cart.total_price > targetCents + 150
    ) {
      const pkg = window.GRAVITY_PACKAGES && window.GRAVITY_PACKAGES[qualifies];
      const code = pkg && pkg.discountCode ? pkg.discountCode : '';
      row.hidden = false;
      row.innerHTML =
        '<span class="cart-package-discount-stale">Package price <strong>' +
        formatMoney(targetCents) +
        '</strong> not applied yet' +
        (code
          ? ' — use <strong>' +
            escAttr(code) +
            '</strong> at checkout or '
          : ' — ') +
        '<button type="button" class="cart-package-discount-retry" data-apply-package-discount>apply package pricing</button></span>';
      return;
    }

    row.hidden = true;
    row.innerHTML = '';
  }

  function renderEmptyCartHtml() {
    if (isCartPage()) {
      const root = shopifyRoot();
      const catalogHandle =
        document.documentElement.dataset.catalogCollection || 'all-in-stock';
      const shopUrl =
        (root.endsWith('/') ? root.slice(0, -1) : root) +
        '/collections/' +
        catalogHandle;
      return (
        '<div class="cart-empty-state">' +
        '<p>Your shopping bag is empty.</p>' +
        '<a href="' +
        escAttr(shopUrl) +
        '" class="btn btn-secondary">Continue browsing</a>' +
        '</div>'
      );
    }
    return (
      '<div class="cart-empty-state">' +
      '<p>Your shopping bag is empty.</p>' +
      '<button type="button" class="btn btn-secondary" data-close-cart>Continue Browsing</button>' +
      '</div>'
    );
  }

  async function renderCart() {
    const lists = cartListEls();
    const subtotals = subtotalEls();
    const checkouts = checkoutBtns();
    if (!lists.length) return;

    const seq = ++renderSeq;

    let cart;
    try {
      cart = await fetchCartWithBundles();
      cart = await reconcilePackageDiscount(cart);
      if (cart._bundleByKey == null) {
        cart._bundleByKey = await fetchBundleComponentsMap();
      }
    } catch (e) {
      if (seq !== renderSeq) return;
      console.error('[GravityCart] fetchCart failed', e);
      setAllInnerHtml(lists, renderCartErrorHtml());
      setAllDisabled(checkouts, true);
      updateCartFeesSection([]);
      return;
    }

    if (seq !== renderSeq) return;

    try {
      updateCartBadge(cart.item_count);
      updateShippingMeter(cart);

      if (!cart.item_count) {
        setAllInnerHtml(lists, renderEmptyCartHtml());
        setAllText(subtotals, formatMoney(0));
        setAllDisabled(checkouts, true);
        updateCartFeesSection([]);
        updateBogoStrip(cart);
        updateBogoSavingsRow(cart);
        bindCartListActions();
        document.dispatchEvent(new CustomEvent('gravity:cart-updated'));
        return;
      }

      setAllDisabled(checkouts, false);
      setAllText(subtotals, formatMoney(cartDisplayTotalCents(cart)));
      updatePackageDiscountRow(cart);
      updateBogoSavingsRow(cart);

      const entries = buildCartDisplayEntriesSafe(cart);
      const partitioned = partitionCartEntries(entries);
      const itemsHtml = partitioned.main
        .map(function (entry, entryIndex) {
          if (entry.kind === 'bundle') {
            return renderBundleHtml(entry, entryIndex);
          }
          return renderCartItemHtml(entry.item, entry.index, cart);
        })
        .join('');
      setAllInnerHtml(lists, itemsHtml);
      updateCartFeesSection(partitioned.fees);
      updateBogoStrip(cart);
      bindCartListActions();
      document.dispatchEvent(new CustomEvent('gravity:cart-updated'));
    } catch (e) {
      if (seq !== renderSeq) return;
      console.error('[GravityCart] renderCart display failed', e);
      setAllInnerHtml(lists, renderCartErrorHtml());
      setAllDisabled(checkouts, true);
      updateCartFeesSection([]);
    }
  }

  function openCartDrawer() {
    drawer()?.classList.add('is-active');
    overlay()?.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    drawer()?.setAttribute('aria-hidden', 'false');
  }

  function closeCartDrawer() {
    drawer()?.classList.remove('is-active');
    overlay()?.classList.remove('is-active');
    document.body.style.overflow = '';
    drawer()?.setAttribute('aria-hidden', 'true');
  }

  async function handleCheckout() {
    const cart = await fetchCartWithBundles();
    if (!cart.item_count) return;

    const guard = window.GravityPackageDiscount;
    if (
      guard &&
      guard.cartHasMixedPackageAndIndividual &&
      guard.cartHasMixedPackageAndIndividual(cart)
    ) {
      alert(
        'Studio packages must be checked out on their own. Remove individual canvases or remove the package before continuing.'
      );
      return;
    }

    if (window.GravityBogoFunnel && window.GravityBogoFunnel.maybePrompt) {
      const blocked = await window.GravityBogoFunnel.maybePrompt(cart, {
        reason: 'checkout',
      });
      if (blocked) return;
    }

    window.location.href = '/checkout';
  }

  async function toggleOrderBump(checked) {
    if (!orderBumpVariantId) return;
    const cart = await fetchCartWithBundles();
    const existing = cart.items.find(
      (i) => String(i.variant_id) === String(orderBumpVariantId)
    );
    if (checked && !existing) {
      await addVariant(orderBumpVariantId, 1, { skipBogoPrompt: true });
    } else if (!checked && existing) {
      await updateCartLine({ key: existing.key, quantity: 0 });
    }
  }

  document.addEventListener('click', (e) => {
    const inCartCard = e.target.closest('[data-product-card].is-in-cart');
    if (inCartCard) {
      e.preventDefault();
      openCartDrawer();
      renderCart();
      return;
    }

    if (e.target.closest('[data-cart-retry]')) {
      e.preventDefault();
      renderCart();
      return;
    }

    if (e.target.closest('[data-apply-package-discount]')) {
      e.preventDefault();
      renderCart();
      return;
    }

    const t = e.target.closest('[data-open-cart]');
    if (t) {
      e.preventDefault();
      openCartDrawer();
      renderCart();
    }
    if (e.target.closest('[data-close-cart]')) closeCartDrawer();
    if (e.target.id === 'cart-overlay') closeCartDrawer();
    if (e.target.closest('.cart-close-btn')) closeCartDrawer();

    if (e.target.id === 'cart-checkout-btn' || e.target.id === 'cart-page-checkout-btn') {
      e.preventDefault();
      handleCheckout();
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.id === 'order-bump-check') {
      toggleOrderBump(e.target.checked);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCartDrawer();
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const id = form.querySelector('[name="id"]')?.value;
    if (!id) return;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);

    const addBtn = document.getElementById('pdp-add-btn');
    const stickyBtn = document.getElementById('pdp-sticky-btn');
    const buttons = [addBtn, stickyBtn].filter(Boolean);
    if (addBtn?.classList.contains('is-loading')) return;

    const prevAddHtml = addBtn ? addBtn.innerHTML : '';
    const prevStickyText = stickyBtn ? stickyBtn.textContent : '';

    function setPdpAddLoading(loading) {
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-loading', loading);
        btn.setAttribute('aria-busy', loading ? 'true' : 'false');
        btn.disabled = loading;
      });
      if (loading) {
        if (addBtn) addBtn.textContent = 'Adding to bag…';
        if (stickyBtn) stickyBtn.textContent = 'Adding to bag…';
      }
    }

    setPdpAddLoading(true);
    try {
      const properties = {};
      const variants = window.GravityProductVariants || [];
      const match = variants.find(function (v) {
        return String(v.id) === String(id);
      });
      const canvasSizes = [
        'XS',
        'Standard',
        'Mid',
        'Large',
        'Large+',
        'XL',
        'XXL',
        'XXXL',
      ];
      let size = '';
      if (match) {
        const optionValues = [match.option1, match.option2, match.option3]
          .concat(match.options || [])
          .map(function (v) {
            return String(v || '').trim();
          })
          .filter(Boolean);
        size =
          optionValues.find(function (v) {
            return canvasSizes.indexOf(v) >= 0;
          }) || '';
        if (size) properties._canvas_size = size;
      }
      const isCanvas = !!size;
      const result = await addVariant(id, qty, {
        properties: Object.keys(properties).length ? properties : undefined,
        isCanvas: isCanvas,
      });
      setPdpAddLoading(false);
      if (result && result.duplicate) {
        if (addBtn) addBtn.innerHTML = prevAddHtml;
        if (stickyBtn) stickyBtn.textContent = prevStickyText;
        alert('This backdrop is already in your bag.');
        return;
      }
      document.dispatchEvent(new CustomEvent('gravity:cart-added'));
    } catch (err) {
      setPdpAddLoading(false);
      if (addBtn) addBtn.innerHTML = prevAddHtml;
      if (stickyBtn) stickyBtn.textContent = prevStickyText;
      alert('Could not add to bag. Please try again.');
    }
  });

  window.GravityCart = {
    addVariant,
    openCartDrawer,
    closeCartDrawer,
    renderCart,
    fetchCart,
    fetchCartWithBundles,
    updateCartLine,
    formatMoney,
    isVariantInCart,
    collectCartVariantIds,
    syncShopCards,
    syncShopCardsFromCache,
  };

  function initProductVariantForm() {
    const form = document.querySelector('form[data-product-form]');
    if (!form) return;
    const idInput = form.querySelector('[name="id"]');
    const variants = window.GravityProductVariants;
    if (!idInput || !variants?.length) return;

    form.addEventListener('change', () => {
      const options = [...form.querySelectorAll('[name^="options"]')].map(
        (el) => el.value
      );
      const match = variants.find((v) =>
        v.options.every((opt, i) => opt === options[i])
      );
      if (match) idInput.value = match.id;
    });
  }

  function openCartFromQuery() {
    const params = new URLSearchParams(window.location.search);
    const openCart = params.get('open_cart');
    let shouldOpen = openCart && openCart.startsWith('1');
    try {
      if (sessionStorage.getItem('gravity_open_cart_after_discount') === '1') {
        sessionStorage.removeItem('gravity_open_cart_after_discount');
        shouldOpen = true;
      }
    } catch (e) {
      /* ignore */
    }
    if (!shouldOpen) return;
    params.delete('open_cart');
    const qs = params.toString();
    const clean =
      window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash;
    history.replaceState({}, '', clean);
    renderCart().then(() => openCartDrawer());
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindCartListActions();
    renderCart().then(function () {
      syncShopCards();
    });
    drawer()?.setAttribute('aria-hidden', 'true');
    initProductVariantForm();
    openCartFromQuery();
  });

  document.addEventListener('gravity:cart-updated', () => {
    syncShopCards();
  });

  document.addEventListener('gravity:cart-added', () => {
    syncShopCards();
  });
})();
